
import { ImageDefinition } from '@/models/image-definition';
import he from 'he';
import { computed, ComputedRef, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'PackagePathSegmentView',
  props: {
    image: {
      type: Object as PropType<ImageDefinition>,
      required: false,
      default: null
    },
    icon: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props) {
    const dataIconValue: ComputedRef<string> = computed(() => {
      return props.icon
          ? he.decode(`&#x${props.icon}`)
          : '';
    });

    return {
      dataIconValue
    };
  }
});
